type AppEnvironment = 'gamma' | 'prod' | 'prod_eu'

export interface Config {
  environment: AppEnvironment
  apiUrl: string
  ocppWebsocketUrl: string
  mobileLinkHandlerUrl: string
  supportedBrowsersRegex?: RegExp
}

const environment = (process.env.REACT_APP_ENV_NAME || 'prod') as AppEnvironment

const configs = {
  gamma: {
    apiUrl: 'https://iehhv31e6a.execute-api.us-east-1.amazonaws.com/gamma',
    ocppWebsocketUrl: 'chargers.gamma.synop.ai/charger',
    mobileLinkHandlerUrl: 'https://open.gamma.synop.app'
  },
  prod: {
    apiUrl: 'https://2ufjtpakn2.execute-api.us-east-1.amazonaws.com/prod',
    ocppWebsocketUrl: 'chargers.synop.ai/charger',
    mobileLinkHandlerUrl: 'https://open.synop.app'
  },
  prod_eu: {
    apiUrl: 'https://w1fcqlqbg5.execute-api.eu-west-1.amazonaws.com/prod-eu',
    ocppWebsocketUrl: 'chargers.eu.synop.ai/charger',
    mobileLinkHandlerUrl: 'https://open.synop.app'
  }
}

function compileSupportedBrowsersRegex() {
  const supportedBrowsers = process.env.NEXT_PUBLIC_SUPPORTED_BROWSERS_REGEX
  if (!supportedBrowsers) return undefined

  try {
    return new RegExp(supportedBrowsers)
  } catch (e) {
    return undefined
  }
}

const envConfig: Config = {
  environment,
  supportedBrowsersRegex: compileSupportedBrowsersRegex(),
  ...configs[environment]
}

export default envConfig
